export const SECTION_ADD_REQUEST = "SECTION_ADD_REQUEST";
export const SECTION_ADD_SUCCESS = "SECTION_ADD_SUCCESS";
export const SECTION_ADD_FAIL = "SECTION_ADD_FAIL";

export const SECTION_DETAIL_REQUEST = "SECTION_DETAIL_REQUEST";
export const SECTION_DETAIL_SUCCESS = "SECTION_DETAIL_SUCCESS";
export const SECTION_DETAIL_FAIL = "SECTION_DETAIL_FAIL";

export const SECTION_UPDATE_REQUEST = "SECTION_UPDATE_REQUEST";
export const SECTION_UPDATE_SUCCESS = "SECTION_UPDATE_SUCCESS";
export const SECTION_UPDATE_FAIL = "SECTION_UPDATE_FAIL";

export const SECTION_DELETE_REQUEST = "SECTION_DELETE_REQUEST";
export const SECTION_DELETE_SUCCESS = "SECTION_DELETE_SUCCESS";
export const SECTION_DELETE_FAIL = "SECTION_DELETE_FAIL";

export const SECTION_LIST_REQUEST = "SECTION_LIST_REQUEST";
export const SECTION_LIST_SUCCESS = "SECTION_LIST_SUCCESS";
export const SECTION_LIST_FAIL = "SECTION_LIST_FAIL";

export const SECTION_STORE_LIST_REQUEST = "SECTION_STORE_LIST_REQUEST";
export const SECTION_STORE_LIST_SUCCESS = "SECTION_STORE_LIST_SUCCESS";
export const SECTION_STORE_LIST_FAIL = "SECTION_STORE_LIST_FAIL";
